import { getRequestConfig } from 'next-intl/server';
import { RoutesRepeater } from './utils/useLocaleRoutes';
import { Pathnames } from 'next-intl/navigation';
import routesData from './routesData.local.json';
import localeRoutes from '@/messages/localeRoutes.json';

export default getRequestConfig(async ({ locale }) => ({
  messages: (await import(`@/messages/${locale}.json`)).default,
}));

export const locales = process.env.NEXT_PUBLIC_LOCALES
  ? process.env.NEXT_PUBLIC_LOCALES?.split(',')
  : ['en'];

const routesRepeater = RoutesRepeater(locales);

const pagesPathnames = getPages();
const staticPagesPathnames = getStaticPages();

export const pathnames = {
  '/category/all': routesRepeater('/{all}', ['all']),
  '/item/[id]': routesRepeater('/{item}/[id]', ['item']),
  '/profile': routesRepeater('/{profile}', ['profile']),
  '/profile/favourites': routesRepeater('/{profile}/{favourites}', [
    'profile',
    'favourites',
  ]),
  '/profile/ads': routesRepeater('/{profile}/{ads}', ['profile', 'ads']),
  '/profile/ads/[ads]': routesRepeater('/{profile}/{ads}/[ads]', [
    'profile',
    'ads',
  ]),
  '/profile/bids': routesRepeater('/{profile}/{bids}', ['profile', 'bids']),
  '/profile/bids/[bids]': routesRepeater('/{profile}/{bids}/[bids]', [
    'profile',
    'bids',
  ]),
  '/profile/buy-history': routesRepeater('/{profile}/{buy-history}', [
    'profile',
    'buy-history',
  ]),
  '/profile/sales-history': routesRepeater('/{profile}/{sales-history}', [
    'profile',
    'sales-history',
  ]),
  '/profile/complaints': routesRepeater('/{profile}/{complaints}', [
    'profile',
    'complaints',
  ]),
  '/job-application': routesRepeater('/{job-application}', ['job-application']),
  //...staticPagesPathnames,
  ...pagesPathnames,
} satisfies Pathnames<typeof locales>;

function getPages() {
  const slugs = Object.keys(routesData);
  const pages = {} as any;
  slugs.map((slug) => {
    const page = routesData[slug as keyof typeof routesData] as any;
    const pageData = {} as any;
    if (page.type === 'page') {
      locales.forEach((locale) => {
        pageData[locale] = '/' + page[('slug-' + locale) as keyof typeof page];
      });
      pages['/' + slug] = pageData;
    } else if (page.type === 'category') {
      locales.forEach((locale) => {
        pageData[locale] = '/' + page[('slug-' + locale) as keyof typeof page];
      });
      pages['/category/' + slug] = pageData;
      if (Object.keys(page.children).length) {
        const subCatSlugs = Object.keys(page.children);
        subCatSlugs.forEach((subCatSlug) => {
          const subPageData = {} as any;
          const subCat = page.children[subCatSlug];
          locales.forEach((locale) => {
            subPageData[locale] =
              '/' +
              page[('slug-' + locale) as keyof typeof page] +
              '/' +
              subCat[('slug-' + locale) as keyof typeof subCat];
          });
          pages['/category/' + slug + '/' + subCatSlug] = subPageData;
        });
      }
    }
  });
  return pages;
}

function getStaticPages() {
  const slugs = Object.keys(localeRoutes);
  const pages = {} as any;
  slugs.map((slug) => {
    const page = localeRoutes[slug as keyof typeof localeRoutes];
    const pageData = {} as any;
    locales.forEach((locale) => {
      pageData[locale] = '/' + page[locale as keyof typeof page];
    });
    pages['/' + slug] = pageData;
  });
  return pages;
}
